import styled from 'styled-components'

const StyledTopic = styled.span`
	font-size: 2.4rem;
`

export { StyledTopic }
